import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default class ImagesList {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.imagesItems = [...this.el.querySelectorAll('.images-list__item')];

        this.init();
        this.setupResize();
    }

    init() {

        if (!this.imagesItems && !this.imagesItems.length) return;

        this.imagesItems.forEach((el) => {
            const title = el.querySelector('.images-list__item-title');

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: 'top 75%',
                    scrub: true
                }
            });

            timeline
                .set(el, { y: '100%' })
                .to(el, { y: '0%', ease: 'power2.out' });

            if (title) {
                gsap.fromTo(title,
                    { 
                        clipPath: 'inset(0 0 100% 0)',
                        opacity: 0,
                        y: '30%'
                    },
                    { 
                        clipPath: 'inset(0 0 0% 0)',
                        opacity: 1,
                        y: '0%',
                        duration: 1,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: el,
                            start: 'top 90%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        this.updateInteraction();
    }

    updateInteraction() {
        if (this.clickHandler) this.el.removeEventListener('click', this.clickHandler);

        this.clickHandler = (e) => {
            const isMobile = window.innerWidth <= 1024;
            if (!isMobile) return;

            const item = e.target.closest('.images-list__item');
            if (!item) return;

            const isActive = item.classList.contains('active');
            this.imagesItems.forEach((el) => el.classList.remove('active'));
            if (!isActive) item.classList.add('active');
        };

        this.el.addEventListener('click', this.clickHandler);
    }

    setupResize() {
        window.addEventListener('resize', () => {
            this.updateInteraction();
        });
    }
}
